module.exports = __webpack_public_path__ + "img/icon-codicon-book.65111eca.svg";